import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProduct(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/product/product/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addUpdateProduct(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/product", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchHKTVData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/hktv", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
